<template>
  <div>
    <v-navigation-drawer
      clipped
      :right="!mobile"
      :app="!mobile"
      permanent
      floating
      :class="{
        'px-6': !mobile,
        'py-4': !mobile
      }"
      :width="width"
      color="#f4f7f9"
    >
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12" :class="{ 'pt-0': mobile }">
          <div class="card-label d-flex flex-row mb-2">
            <v-icon>mdi-calendar-export</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              Upcoming End of Lease
            </p>
          </div>
          <v-select
            v-model="upcomingEndOfLeaseAfter"
            class="mb-2 mt-0"
            dense
            solo
            flat
            hide-details
            :items="upcomingEndOfLeaseShowItems"
            @change="updateUpcomingEndOfLeaseAfter"
          >
            <template v-slot:selection="{ item }">
              <p class="caption">Show the next: {{ item.text }}</p>
            </template>
          </v-select>
          <v-card
            v-if="!loading"
            id="upcomingEndOfLease"
            elevation="0"
            class="due-card"
            hover
          >
            <UpcomingEndOfLease
              class="pa-1"
              :loading="loading || upcomingMoveOutLoading"
              :items="upcomingMoveOutItems"
            ></UpcomingEndOfLease>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-calendar-import</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Due PDCs</p>
          </div>
          <v-card
            v-if="!loading"
            id="duePdcs"
            elevation="0"
            class="due-card"
            hover
          >
            <DueTable
              :loading="loading"
              :items="duePdcs"
              type="pdc"
              caption="Due PDCs"
              class="pa-1"
            >
            </DueTable>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-calendar-alert</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Overdue Rentals</p>
          </div>
          <v-card
            v-if="!loading"
            id="overdue"
            elevation="0"
            class="due-card"
            hover
          >
            <DueTable
              :due-table="dueTable"
              :loading="loading"
              :items="overdueItems"
              type="bed"
              caption="Overdue Rentals"
              class="pa-1"
            >
            </DueTable>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-calendar-today</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              Rentals Due Today
            </p>
          </div>
          <v-card
            v-if="!loading"
            id="dueToday"
            elevation="0"
            class="due-card"
            hover
          >
            <DueTable
              :due-table="dueTable"
              :loading="loading"
              :items="dueItems"
              type="bed"
              caption="Rentals Due Today"
              class="pa-1"
            >
            </DueTable>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-calendar</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              Rentals Due Next Week
            </p>
          </div>
          <v-card
            v-if="!loading"
            id="upcoming"
            elevation="0"
            class="due-card"
            hover
          >
            <DueTable
              :due-table="dueTable"
              :loading="loading"
              :items="upcomingItems"
              type="bed"
              caption="Rentals Due Next Week"
              class="pa-1"
            >
            </DueTable>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="access.read">
        <v-col cols="12" sm="12" md="12">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-calendar-import</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              Upcoming Move Ins
            </p>
          </div>
          <v-card
            v-if="!loading"
            id="upcomingMoveInReservations"
            elevation="0"
            class="due-card"
            hover
          >
            <DueTable
              :loading="loading"
              :items="upcomingMoveInReservationItems"
              type="reservation"
              caption="Upcoming Move-Ins"
              class="pa-1"
            >
            </DueTable>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="list-item-three-line"
            loading
            class="mx-auto"
            height="100"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-navigation-drawer>
    <v-tour
      name="rightDrawerTour"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import DueTable from '../components/dashboard/DueTable.vue'
import UpcomingEndOfLease from '../components/dashboard/UpcomingEndOfLease.vue'
import { dayjs } from '../util/date'

export default {
  components: {
    DueTable,
    UpcomingEndOfLease
  },
  props: ['initUnits', 'width'],
  data() {
    return {
      loading: true,
      upcomingMoveInReservations: [],
      tourSteps: [
        {
          target: '#upcomingEndOfLease',
          header: {
            title: 'Upcoming End of Lease'
          },
          content:
            'This shows the list of beds whose end of lease is approaching.',
          params: {
            placement: 'bottom-start'
          },
          offset: -500
        },
        {
          target: '#upcomingMoveInReservations',
          header: {
            title: 'Upcoming Move Ins'
          },
          content: 'This shows the tenants approaching their move in date.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        },
        {
          target: '#overdue',
          header: {
            title: 'Overdue Payments'
          },
          content: 'This shows which units have overdue payments.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        },
        {
          target: '#dueToday',
          header: {
            title: 'Payments Due Today'
          },
          content: 'This shows the payments that are due today.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        },
        {
          target: '#upcoming',
          header: {
            title: 'Upcoming Payments'
          },
          content: 'This shows the payments that are due in the next 7 days.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        }
      ],
      tourOptions: {
        startTimeout: 500
      },
      tourCallbacks: {
        onStop: this.stopTourCallback
      },
      upcomingEndOfLeaseAfter: 30,
      upcomingEndOfLeaseShowItems: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '1 month', value: 30 },
        { text: '2 months', value: 60 },
        { text: '6 months', value: 180 }
      ],
      upcomingMoveOutLoading: false
      // duePdcs: [],
    }
  },
  computed: {
    dueTable() {
      return this.$store.getters['units/getDueTable']
    },
    overdueItems() {
      return this.dueTable.overdue.map((item) => {
        return {
          bed: this.bedFullName(item.bedId),
          dueDate: dayjs(item.paidUntilDate).format('YYYY-MM-DD'),
          bedId: item.bedId
        }
      })
    },
    dueItems() {
      return this.dueTable.due.map((item) => {
        return {
          bed: this.bedFullName(item.bedId),
          dueDate: dayjs(item.paidUntilDate).format('YYYY-MM-DD'),
          bedId: item.bedId
        }
      })
    },
    upcomingItems() {
      return this.dueTable.upcoming.map((item) => {
        return {
          bed: this.bedFullName(item.bedId),
          dueDate: dayjs(item.paidUntilDate).format('YYYY-MM-DD'),
          bedId: item.bedId
        }
      })
    },
    upcomingMoveOutItems() {
      return this.moveOutTable.map((item) => {
        return {
          bed: this.bedFullName(item.bedId),
          moveOut: dayjs(item.moveOutDate).format('YYYY-MM-DD'),
          bedId: item.bedId
        }
      })
    },
    upcomingMoveInReservationItems() {
      return this.upcomingMoveInReservations.map((item) => {
        return {
          reservationId: item.reservationId,
          moveInDate: dayjs(item.moveInDate).format('YYYY-MM-DD')
        }
      })
    },
    access() {
      return this.$root.$roleAccess('dashboard_main').access
    },
    aliases() {
      return this.$store.getters['users/getAliases']
    },
    duePdcs() {
      return this.$store.getters['pdcs/getDuePdcs']
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    occupiedUnits() {
      return this.units
        .filter((u) => u.status === 'occupied')
        .map((unit) => {
          return {
            text: `${unit.bedName} / ${this.getTenantName(
              unit.tenant_details
            )}`,
            value: unit.bedId
          }
        })
    },
    moveOutTable() {
      return this.$store.getters['units/getUpcomingMoveOut']
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted() {
    this.upcomingEndOfLeaseAfter =
      (this.property.defaults && this.property.defaults.upcomingMoveOutAfter) ||
      30
    Promise.all([
      this.$store.dispatch('reservations/fetchUpcomingMoveInReservationAction'),
      this.$store.dispatch('units/fetchDueTableAction'),
      this.$store.dispatch('units/fetchUpcomingMoveOutAction', {
        after: this.upcomingEndOfLeaseAfter
      })
    ]).then((values) => {
      const [upcomingMoveInReservations] = values
      this.loading = false
      this.upcomingMoveInReservations = upcomingMoveInReservations
      // this.duePdcs = this.getDuePdcs.map(pdc => {
      //   pdc.tenantName = this.getAlias(pdc.tenantId) || this.getTenantName(pdc.tenant_details)
      //   return pdc
      // })
      // this.getBedsListOccupied(this.$store.state.units.floors, this.bedsListOccupied, '')
    })
  },
  methods: {
    bedFullName(bedId) {
      const unit = this.occupiedUnits.find((unit) => bedId === unit.value)
      if (unit) return unit.text
      return ``
    },
    async stopTourCallback() {
      await this.$store.dispatch('auth/stopTour', { section: 'rightDrawer' })
      this.$tours['showUnitsTour'].start()
    },
    getTenantName(tenant) {
      if (!tenant) return ''
      const alias = this.getAlias(tenant.userId)
      if (alias) {
        return alias
      }
      let displayName = ''
      if (tenant.firstName) {
        displayName += tenant.firstName + ' '
        if (tenant.lastName) {
          displayName += tenant.lastName + ' '
        }
      } else {
        return (displayName = tenant.username)
      }

      return displayName
    },
    getAlias(tenantId) {
      const alias = this.aliases.find((a) => a.tenantId === tenantId)
      return alias && alias.name
    },
    async updateUpcomingEndOfLeaseAfter() {
      this.upcomingMoveOutLoading = true
      await this.$store.dispatch('units/fetchUpcomingMoveOutAction', {
        after: this.upcomingEndOfLeaseAfter
      })
      this.upcomingMoveOutLoading = false
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px !important;
}
.due-card {
  max-height: 200px;
  overflow: scroll;
  border-radius: 12px !important;
  background-color: #ffffff;
}
</style>
